import { TypedHtmlElements } from "@cervval.js/client-html5-core/src/components/typedHtmlElements.decorator";
import { TypedWebComponentOptions, WebComponentOptions } from "@cervval.js/client-html5-core/src/components/typedWebComponentOptions.decorator";
import { WebComponent } from "@cervval.js/client-html5-core/src/components/webComponent";
import { FLEX_CONTAINER_COLUMN, FLEX_ITEM_AUTO, W_100 } from "@cervval.js/client-html5-core/src/tools/cssClasses.tools";
import { CustomElement } from "@cervval.js/client-html5-spa/navigation";
import { BookingWeek } from "@ehealth_tools/common-booking/src/data/booking.dto";
import { TimeSlotsEditor } from "../timeslotsEditor/timeslotsEditor";
import { WeekSlots } from "../weekSlot/weekSlots.component";
import { I18nTypicalWeek } from "./typicalWeek.component.i18n";

export interface TypicalWeekOptions {
    currentWeek?: BookingWeek;
}

const defaultTypicalWeekOptions: TypicalWeekOptions = {
    //
};


@CustomElement({
    name: "typical-week",
    template: require("./typicalWeek.component.html"),
    style: require("./typicalWeek.component.scss"),
    i18n: require("./typicalWeek.component.i18n").I18n,
    elementCssClasses: [FLEX_CONTAINER_COLUMN, FLEX_ITEM_AUTO, W_100]
})

export class TypicalWeek<I18n extends I18nTypicalWeek = I18nTypicalWeek> extends WebComponent<I18n> {

    @TypedWebComponentOptions(defaultTypicalWeekOptions)
    public readonly options!: WebComponentOptions<TypicalWeekOptions>;


    @TypedHtmlElements({ ensureLoadedClasses: [WeekSlots, TimeSlotsEditor] })
    private _components!: {
        typicalWeekDescription: HTMLDivElement,
        weekSlots: WeekSlots,
        defaultTimeSlotsEditor: TimeSlotsEditor
    };

    /** Init component */
    public override init(): void {

        this._components.weekSlots.options.setAndRefreshIfChanged({
            onSelectDay: (days) => {
                this._components.defaultTimeSlotsEditor.options.setAndRefreshIfChanged({ selectedDays: days });
            }
        });

        this._components.defaultTimeSlotsEditor.options.setAndRefreshIfChanged({
            onChange: () => {
                this._components.weekSlots.refresh();
            }
        });
    }

    /** Reset column selection, table and weekDay   */
    public override refresh(): void {
        this._components.typicalWeekDescription.innerHTML = this.i18n.description;
        this._components.weekSlots.refreshColumnSelection(true);
        this._components.weekSlots.options.setAndRefreshIfChanged({ currentWeek: this.options.currentWeek });
        this._components.defaultTimeSlotsEditor.options.setAndRefreshIfChanged({ currentWeek: this.options.currentWeek });
    }
}